import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CircleHelp } from "lucide-react";

export const ComparisonMetricLabel = ({ label, description, dataTestId }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center gap-2 text-left"
            data-testid={dataTestId}
          >
            <span className="font-medium text-foreground">{label}</span>
            <CircleHelp className="h-4 w-4 text-muted-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs text-xs text-white">{description}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};